"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateTestDataDto = instanceOfCreateTestDataDto;
exports.CreateTestDataDtoFromJSON = CreateTestDataDtoFromJSON;
exports.CreateTestDataDtoFromJSONTyped = CreateTestDataDtoFromJSONTyped;
exports.CreateTestDataDtoToJSON = CreateTestDataDtoToJSON;
exports.CreateTestDataDtoToJSONTyped = CreateTestDataDtoToJSONTyped;
/**
 * Check if a given object implements the CreateTestDataDto interface.
 */
function instanceOfCreateTestDataDto(value) {
    if (!('baseEmail' in value) || value['baseEmail'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    if (!('nurseCount' in value) || value['nurseCount'] === undefined)
        return false;
    if (!('facilityCount' in value) || value['facilityCount'] === undefined)
        return false;
    if (!('multiplier' in value) || value['multiplier'] === undefined)
        return false;
    return true;
}
function CreateTestDataDtoFromJSON(json) {
    return CreateTestDataDtoFromJSONTyped(json, false);
}
function CreateTestDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'baseEmail': json['baseEmail'],
        'password': json['password'],
        'nurseCount': json['nurseCount'],
        'facilityCount': json['facilityCount'],
        'multiplier': json['multiplier'],
    };
}
function CreateTestDataDtoToJSON(json) {
    return CreateTestDataDtoToJSONTyped(json, false);
}
function CreateTestDataDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'baseEmail': value['baseEmail'],
        'password': value['password'],
        'nurseCount': value['nurseCount'],
        'facilityCount': value['facilityCount'],
        'multiplier': value['multiplier'],
    };
}
//# sourceMappingURL=CreateTestDataDto.js.map